/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'fallback': {
    width: 16,
    height: 16,
    viewBox: '0 0 400 300',
    data: '<g _fill="none" fill-rule="evenodd"><path pid="0" _fill="#F5F5F5" d="M0 0h400v300H0z"/><path pid="1" d="M195.089 122.831l-6.517 16.95-14.613 5.253-4.246 10.804L108 179.428l11.948-30.726 75.141-25.87zm54.349 0l-4.171 10.408-14.002 5.154-4.668 11.994-60.974 29.042 12.115-30.43 71.7-26.168zM292 120.857l-68.754 50.016 11.426-28.92L292 120.857z" _fill="#DEDEDE" fill-rule="nonzero"/></g>'
  }
})
